import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { first } from "rxjs/operators";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { Annee } from "src/app/parametrage/core/model/annee";
import { Conges } from "src/app/parametrage/core/model/conges";
import { Employee } from "src/app/parametrage/core/model/employee/employee";
import { AnneeService } from "src/app/parametrage/core/service/annee.service";
import { CongesService } from "src/app/parametrage/core/service/conges.service";
import { AddCongesComponent } from "src/app/parametrage/user/add-conges/add-conges.component";
import { EditCongesComponent } from "src/app/parametrage/user/edit-conges/edit-conges.component";
import { KeycloakService } from "src/app/core/services/auth/keycloak.service";

@Component({
  selector: "app-conges",
  templateUrl: "./conges.component.html",
  styleUrls: ["./conges.component.scss"],

  //
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
  //
})
export class CongesComponent implements OnInit {
  annees: Annee[];

  conges: Conges[];
  congesArray: Array<Conges[]> = [];

  displayedAnneesColumnsList: string[] = ["annee", "actions"];

  constructor(
    private modalService: NgbModal,
    private _keycloakService: KeycloakService,
    private _anneeService: AnneeService,
    private _congesService: CongesService
  ) {}

  ngOnInit() {
    this.getAllAnnee();
  }

  getAllAnnee() {
    this._anneeService.getAll().subscribe(
      (data) => {
        this.annees = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getCongesByAnnee(annee) {
    this._congesService.getListCongesByAnneeAndCurrentUsername(annee).subscribe(
      (data) => {
        this.conges = data;
        this.congesArray[annee] = this.conges;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  add(annee): void {
    const modalRef = this.modalService.open(AddCongesComponent, {
      centered: true,
    });
    modalRef.componentInstance.annee = annee;
    modalRef.componentInstance.username = this._keycloakService.getUsername();

    modalRef.result.then(
      (data) => {
        // on close
        this.getCongesByAnnee(annee);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  edit(annee, congeId): void {
    const modalRef = this.modalService.open(EditCongesComponent, {
      centered: true,
    });
    modalRef.componentInstance.congeId = congeId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getCongesByAnnee(annee);
      },
      (reason) => {
        // on dismiss
      }
    );
  }
}
